import { SESSION_TIME } from './constants'

export const clearSession = () => {
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('refreshToken')
  sessionStorage.removeItem('tokenExpiry')
}

export const updateSessionToken = (token, refreshToken) => {
  sessionStorage.setItem('token', token)
  sessionStorage.setItem('refreshToken', refreshToken)
  if (localStorage.getItem('refreshToken')) {
    localStorage.setItem('refreshToken', refreshToken)
  }
}

export const isTokenValid = () => {
  const tokenExpiry = sessionStorage.getItem('tokenExpiry')
  const token = sessionStorage.getItem('token')
  const currentTime = Date.now()

  return !!(token && tokenExpiry && parseInt(tokenExpiry) > currentTime)
}

export const addSessionTime = () => {
  if (isTokenValid()) {
    const newExpiry = Date.now() + SESSION_TIME
    sessionStorage.setItem('tokenExpiry', newExpiry.toString())
  }
}

export const addSessionToken = (token, refreshToken, expiresIn) => {
  if (!token || !expiresIn) return

  sessionStorage.setItem('token', token)

  if (refreshToken) {
    sessionStorage.setItem('refreshToken', refreshToken)
  }

  const expiryTime = Date.now() + expiresIn * 1000
  sessionStorage.setItem('tokenExpiry', expiryTime.toString())
}
